/* eslint-disable prettier/prettier */
/* eslint-disable */

import connectReducers from '../utils/connectReducers';

import { GET_OLYMPIAD_LEVELS } from '../actions';

import { FAILURE, REQUEST, SUCCESS } from '../actions/utils';

import { ICommonResponse, IDictionaryItem } from '../api/types';

import genericReducers from './genericReducer';

import { IReducers } from '.';

export type OlympiadLevelsState = ICommonResponse<IDictionaryItem>;

const initialState = {} as ICommonResponse<IDictionaryItem>;
const generic = genericReducers<OlympiadLevelsState>();
const olympiadLevels: IReducers<OlympiadLevelsState> = {
  [GET_OLYMPIAD_LEVELS[REQUEST]]: generic.get.request,
  [GET_OLYMPIAD_LEVELS[SUCCESS]]: generic.get.success,
  [GET_OLYMPIAD_LEVELS[FAILURE]]: generic.get.failure,
};

export default connectReducers(initialState, olympiadLevels);
